export default "__VITE_ASSET__c8jPN_ZR__"